/**
 * Execute Operation Actor
 *
 * XState actor that calls the appropriate backend API based on operation type.
 * This is used in the OPERATING.executing phase for operations that need
 * to trigger a backend process (SET_COMPANIES, SET_TAGS, etc.)
 *
 * Navigation operations (NAVIGATE) don't need execution and skip this phase.
 */
import { fromPromise } from 'xstate'
import {
  performSetCompanies,
  performSetTags,
  performSetGpos,
  performSetDeals,
  performSetContacts,
  performSetCompanyNotes,
} from '../../importer-api'
import { OperationType } from '../types'

export interface ExecuteOperationInput {
  importNumber: number
  operationType: OperationType
}

export type ExecuteOperationOutput = void

export const executeOperationActor = fromPromise<
  ExecuteOperationOutput,
  ExecuteOperationInput
>(async ({ input }) => {
  switch (input.operationType) {
    case OperationType.SET_COMPANIES:
      await performSetCompanies(input.importNumber)
      break
    case OperationType.SET_TAGS:
      await performSetTags(input.importNumber)
      break
    case OperationType.SET_GPOS:
      await performSetGpos(input.importNumber)
      break
    case OperationType.SET_DEALS:
      await performSetDeals(input.importNumber)
      break
    case OperationType.SET_CONTACTS:
      await performSetContacts(input.importNumber)
      break
    case OperationType.SET_NOTES:
      await performSetCompanyNotes(input.importNumber)
      break
    case OperationType.NAVIGATE:
      // Navigation doesn't need execution - this should never be called
      throw new Error(
        'NAVIGATE operations should not reach the executing phase'
      )
    default:
      throw new Error(`Unknown operation type: ${input.operationType}`)
  }
})
